<template>
    <App >
      <AppBar style="flex-grow:1;position:fixed;top:0;right:0;width:50%;;z-index:101;background:none;" :closable="false">
          <div class="flex-wrap">
          <IconTabs :items="menus" :current="formView" @on-select="formView=$event" />
        </div>
          <div>
            <AppAvatar v-if="uid" />
          </div>
      </AppBar>
      <AppMask title="任吾行 — 表单设计器" iconRight="table" :loading="!is_ready" >
        <div v-if="uid" style="font-size:16px;font-weight:bold;color:var(--primary)">系统登录中,请稍后</div>
      </AppMask>
      <BaseLoadingModal v-if="is_ready" :value="loading" title="正在加载表单" />
  
      <AppClient  class="flex-wrap" style="align-items:stretch;top:0;">
        <keep-alive>
          <template v-if="formView=='editor'">
            <TableEditor
              ref="editor"
              v-model="table"
              style="height:100%"
              @on-event="handleEvent"
            />
          </template>
        </keep-alive>
      </AppClient>
  
    </App>
  </template>
  
  <script>
  import responsableMixin from '@/mixins/responsable';
  import App from '@/components/app/app';
  import AppBar from '@/components/app/bar';
  import AppAvatar from '@/components/app/avatar';
  import AppMask from '@/components/app/mask-loading';
  import AppClient from '@/components/app/client';
  import IconButton from '@/components/app/IconButton';
  import IconTabs from '@/components/app/IconTabs';
  import TableEditor from '@/components/table/zzl/editor';
  import TableTest from '@/components/table/zzl/test';
  export default {
    components: {App, AppBar, AppMask, AppClient, IconButton, IconTabs, TableEditor, TableTest, AppAvatar},
    data() {
      return {
        formView: 'editor',
        loading: false,
        is_ready: false,
        uid: null,
        binding_form:null,
        table: {
          id: 'create',
          name: '新建报表',
          cols: [{
          id:'index',
          title:"序号",
          width:100,
          type:'index',
          system:true
        },{
          id:'projectName',
          title:"项目名称",
          width:200,
          type:'projectName',
          system:true
        }],
        },
  
      };
    },
    mixins: [responsableMixin],
    mounted() {
      this.Login(this.$route.query.uid)
    },
    methods: {
      handleEvent(e) {
       
      },
      Login(uid) {
        this.is_ready = false;
        this.$store.dispatch('session/login_zzl', {uid}).then((res)=>{
  
        }).catch((e)=>{
          this.Error('登录失败,启用离线模式');
        }).finally(()=>{
          this.is_ready = true;
        });
      },
     
    },
    computed: {
      menus() {
        const def_items = [{
          icon: 'edit',
          name: '表单设计',
          key: 'editor',
        }
        ];
        const items = [...def_items];
        return items;
      },
    },
  };
  </script>
  
  <style>
  
  </style>
  